import React, {PureComponent, Component} from 'react';
import {ART_DIRECTORY} from 'constants';
import GridLink from './GridLink';
import PictureList from 'ui-components/PictureList';
import ErrorBoundary from 'ui-components/ErrorBoundary';
import {searchWork} from 'utils/search';
import Pager from 'ui-components/Pager';
import Credits from 'components/Credits';
import {Fader} from 'ui-components/animations';


export class GridWrapper extends PureComponent{
	static defaultProps = {
		pageSize: 100,
		thumbHeightMinimum: 150,
		useGridLink: false,
		waitForLoad: false
	}

	render(){
		let {
			pageSize,
			works,
			thumbHeightMinimum,
			useGridLink,
			waitForLoad
		} = this.props;
		return (
			<Pager
				pageSize={pageSize}
				items={works}
				searchFunc={searchWork}
			>{({
				pageSize,
				items,
				currentPage,
				numPages
			}) =>
				<Grid
					{...this.props}
					items={items}
					currentPage={currentPage}
					numPages={numPages}
					pageSize={pageSize}
				/>
			}</Pager>
		);
	}
}
export default GridWrapper;


export class Grid extends Component{
	constructor(props){
		super(props);
		this.state = {hovering: null};
	}

	navigateTo = id => {
		this.props.navigateTo(
			`/gallery/${id}`
		);
	}

	handleClick = work => {
		this.navigateTo(work.id);
	}

	// bubbled clicks 
	onClickWrapper = (e) => {
		let id = e.target.getAttribute('data-id');
		this.navigateTo(id);
	}

	// hovering
	setHover = (w) => {
		let {hovering} = this.state;
		if (!hovering || hovering.id !== w.id){
			this.setState({hovering: w});
		}
	}
	clearHover = () => {
		this.setState({hovering: null});
	}

	render(){
		let {
			pageSize,
			items,
			thumbHeightMinimum,
			useGridLink,
			waitForLoad
		} = this.props;
		let {hovering} = this.state;

		return (
			<div className="grid" onClick={this.onClickWrapper}>
				<ErrorBoundary>
					{useGridLink 
					? items.map(w =>
						<GridLink
							key={w.id}
							piece={w}
							onMouseEnter={this.setHover.bind(null, w)}
							onMouseLeave={this.clearHover}
						/>
					) : (
						<PictureList
							pictureRoot={ART_DIRECTORY}
							pictures={items}
							extraWidth={4}
							onMouseEnter={this.setHover}
							onMouseLeave={this.clearHover}
							extraHeight={4}
							thumbHeightMinimum={thumbHeightMinimum}
						/>
					)}
				</ErrorBoundary>
				<Fader>{hovering && (
					<div>
						<Credits
							work={hovering}
							visibleOnPropsChange={true}
							delay={0}
						/>
					</div>
				)}</Fader>
			</div>
		);
	}

}